export const API_ENROLMENTS_INDEX = 'API_ENROLMENTS_INDEX'
export const API_ENROLMENTS_SET_ALL_FILTERS = 'API_ENROLMENTS_SET_ALL_FILTERS'

export const API_ENROLMENTS_FACETS_INDEX = 'API_ENROLMENTS_FACETS_INDEX'
export const API_ENROLMENTS_FACETS_INDEX_LOADING = 'API_ENROLMENTS_FACETS_INDEX_LOADING'
export const API_ENROLMENTS_FACETS_INDEX_SUCCESS = 'API_ENROLMENTS_FACETS_INDEX_SUCCESS'
export const API_ENROLMENTS_FACETS_INDEX_FAILURE = 'API_ENROLMENTS_FACETS_INDEX_FAILURE'

export const API_ENROLMENTS_ALL_FACETS_INDEX = 'API_ENROLMENTS_ALL_FACETS_INDEX'
export const API_ENROLMENTS_ALL_FACETS_INDEX_SUCCESS = 'API_ENROLMENTS_ALL_FACETS_INDEX_SUCCESS'
export const API_ENROLMENTS_ALL_FACETS_INDEX_FAILURE = 'API_ENROLMENTS_ALL_FACETS_INDEX_FAILURE'

export const loading = () => ({
  type: API_ENROLMENTS_FACETS_INDEX_LOADING
})

export const fetch = () => ({
  type: API_ENROLMENTS_INDEX
})

export const setAllFilters = (filters: any) => ({
  type: API_ENROLMENTS_SET_ALL_FILTERS,
  ...filters,
})

export const fetchEnrolmentFacets = () => ({
  type: API_ENROLMENTS_FACETS_INDEX
})

export const fetchAllEnrolmentFacets = () => ({
  type: API_ENROLMENTS_ALL_FACETS_INDEX
})
